<button
  type="button"
  class="munily-icon-area-card"
  [class.munily-icon-area-card--selected]="status === 'selected'"
  [class.munily-icon-area-card--disabled]="disabled"
  [attr.aria-pressed]="status === 'selected'"
  [attr.aria-disabled]="disabled"
  (click)="onClick()"
>
  <span class="munily-icon-area-card__pic" aria-hidden="true">
    <img *ngIf="imageUrl; else iconFallback" class="munily-icon-area-card__img" [src]="imageUrl" alt="" />

    <ng-template #iconFallback>
      <mat-icon *ngIf="icon" class="munily-icon-area-card__icon" [ngClass]="iconSet">{{ icon }}</mat-icon>
    </ng-template>

    <mat-icon
      *ngIf="status === 'selected'"
      class="munily-icon-area-card__check material-symbols-rounded"
      aria-hidden="true"
    >
      check_circle
    </mat-icon>
  </span>

  <span class="munily-icon-area-card__title">
    {{ title }}
  </span>
</button>

